module.exports = {
      id: "icon-air-tickets-usage",
      viewBox: "0 0 57 45",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-air-tickets",
      toString: function () {
        return this.url;
      }
    }